import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { isNumber } from 'lodash';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  UnitsTransmissionStatus,
  UnitWithTransmissionStatus,
} from 'src/app/units/models/unit-transmission-status';
import { UnitTransmissionStatusService } from 'src/app/units/services/unit-transmission-status.service';

@Component({
  selector: 'app-unit-list',
  templateUrl: './unit-list.component.html',
  styleUrls: ['./unit-list.component.scss'],
})
export class UnitListComponent implements OnInit, OnDestroy {
  @Input() id?: number;
  @Input() inLive?: boolean; //
  @Input() data?: UnitWithTransmissionStatus[]; //
  @Input() filterBy: UnitWithTransmissionStatus[] = [];

  unitTxStates$: Observable<UnitsTransmissionStatus[]>;
  _unitTxStates$: Subscription | undefined;

  unitList$: BehaviorSubject<UnitWithTransmissionStatus[]> =
    new BehaviorSubject<UnitWithTransmissionStatus[]>([]);

  constructor(private unitTrasmitionService: UnitTransmissionStatusService) {
    this.unitTxStates$ = unitTrasmitionService.getUnitsTransmissionStates;
  }

  ngOnInit(): void {
    this.initChart();
  }
  ngOnDestroy(): void {
    this._unitTxStates$?.unsubscribe();
  }
  private initChart(): void {
    if (this.inLive && isNumber(this.id)) {
      this._unitTxStates$?.unsubscribe();
      this._unitTxStates$ = this.unitTxStates$
        .pipe(
          map((txs) => {
            txs
              .filter((tx) => [this.id].includes(tx.transmissionStatusId))
              .filter((tx) => {
                if (this.filterBy.length > 0) {
                  tx.unitsTransmissions = tx.unitsTransmissions.filter((u) =>
                    this.filterBy.some((T) => T.GNSSIMEI == u.GNSSIMEI)
                  );
                }
                return tx;
              })
              .map((tx) => {
                this.unitList$.next(tx.unitsTransmissions);
              });
          })
        )
        .subscribe();
    } else {
      if (this.data) {
      }
    }
  }
}
